import { QueryObserverOptions, useQuery } from '@tanstack/react-query';

import { UnknownObject } from '@tulp';

import { JobPositionQueryStore } from '../query-store';

export function useGetJobPositions(options?: QueryObserverOptions<string[]>) {
  return useQuery({ ...JobPositionQueryStore.all, ...((options ?? {}) as UnknownObject) });
}
